import { withSpaContainer } from '@nab/x-spa-react';
import type { SpaContainerProps } from '@nab/x-spa-react';
import { createUI } from '@nab/nui-react';

/**
 * Shell SPA Container for NAB-X SDK v5.
 *
 * Composes `withSpaContainer` (x-spa context) with NUIT `createUI`
 * (theme, global style, styled-components stylesheet manager).
 *
 * Pass this to `start({ Container })` and `<MiniAppInstance Container={...} />`.
 */
export const ShellContainer = createUI<SpaContainerProps>([withSpaContainer]);
